import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, DollarSignIcon, TrendingUpIcon, ZapIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    icon: DollarSignIcon,
    iconColor: 'text-success',
    bgColor: 'bg-success/10',
    factor: 'El factor "Ahorro"',
    quote: 'Increíble. Yo gastaba casi 4 dólares solo en la crema para rellenar mis tortas. Con la técnica de emulsión del manual, bajé ese costo a menos de 1 dólar y mis clientes ni se dieron cuenta del cambio. ¡El sabor es el mismo!',
    author: 'Mariela G.',
    role: 'Emprendedora desde casa'
  }, {
    icon: TrendingUpIcon,
    iconColor: 'text-amber',
    bgColor: 'bg-amber/10',
    factor: 'El factor "Ganancia"',
    quote: 'Por fin entiendo dónde se me iba el dinero. La Hoja de Costo Real me abrió los ojos; estaba regalando mi trabajo por no contar el gas y los envases. Ayer vendí mi primer lote de 12 porciones y ya recuperé lo que pagué por el libro.',
    author: 'Carlos R.',
    role: ''
  }, {
    icon: ZapIcon,
    iconColor: 'text-terracotta',
    bgColor: 'bg-terracotta/10',
    factor: 'El factor "Venta Rápida"',
    quote: 'Apliqué el protocolo de ventas por WhatsApp hoy a las 10 am y para mediodía ya tenía todo el lote de chocolate vendido y pagado por adelantado. El "antojo de 1 dólar" funciona de maravilla.',
    author: 'Lucía V.',
    role: ''
  }];
  return <section className="py-20 px-6 bg-cream" data-id="element-138">
      <div className="max-w-5xl mx-auto" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-140">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-141">
            Lo que dicen quienes ya empezaron
          </h2>
          <p className="text-xl text-chocolate/70" data-id="element-142">
            Resultados reales de personas que aplicaron el método
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-143">
          {testimonials.map((testimonial, index) => {
          const Icon = testimonial.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="bg-white p-6 md:p-8 rounded-3xl shadow-warm relative" data-id="element-144">
                {/* Quote Icon */}
                <div className="absolute -top-4 -left-4 opacity-10" data-id="element-145">
                  <QuoteIcon className="w-20 h-20 text-chocolate-dark" data-id="element-146" />
                </div>

                {/* Factor Badge */}
                <div className="relative z-10 mb-6" data-id="element-147">
                  <div className={`inline-flex items-center gap-2 ${testimonial.bgColor} px-4 py-2 rounded-full`} data-id="element-148">
                    <Icon className={`w-5 h-5 ${testimonial.iconColor}`} data-id="element-149" />
                    <span className="font-bold text-sm text-chocolate-dark" data-id="element-150">
                      {testimonial.factor}
                    </span>
                  </div>
                </div>

                {/* Quote */}
                <blockquote className="relative z-10 mb-6" data-id="element-151">
                  <p className="text-chocolate/90 leading-relaxed italic" data-id="element-152">
                    "{testimonial.quote}"
                  </p>
                </blockquote>

                {/* Author */}
                <div className="relative z-10 border-t border-cream-dark pt-4" data-id="element-153">
                  <p className="font-bold text-chocolate-dark" data-id="element-154">
                    {testimonial.author}
                  </p>
                  {testimonial.role && <p className="text-sm text-chocolate/60" data-id="element-155">
                      {testimonial.role}
                    </p>}
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}